import Header from '../components/Header'
import Footer from '../components/Footer'
import Head from '../components/Head'
import * as common from '../common/commonFunction'
import { useSpring, animated } from 'react-spring';
import { useState,useEffect } from 'react';
import $ from 'jquery';
import axios from "axios";
import {ANNOUNCEMENT} from "../lib/global_variable"

const Announcement = () => {

    const [state, toggle] = useState(true)
    const [page, setPage] = useState(0);
    const { x } = useSpring({ from: { x: 0 }, x: state ? 1 : 0, config: { duration: 2000 } })
    const [announcement, setAnnouncement] = useState([]); //subProject list

    useEffect(() => {
        getAnnouncement();
    }, [])

    const getAnnouncement = async () => {

        //get announcement
        const option = {
            url: "/announcement/notice/all?pageSize=20&currentPage="+page,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data',
            }
        }

        axios(option)
            .then(response => {
                if (response.data.code === 200) {
                    setAnnouncement(response.data.data);
                }

            });
    }

    const decodeHtml = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    const clickEvent = (e) => {

        console.log($(e.target));
        console.log($(e.target).parents('li'));
        $(e.target).parents('li').find('.submenu').toggle('fast');

        if (!$(e.target).parents('li').hasClass('open')) {
            $(e.target).parents('li').addClass('open');
        } else {
            $(e.target).parents('li').removeClass('open');
        }

    }


    return (
        <>
            <Head />
            <Header />
            <div className="container" style={{ width: "100%" }} onClick={() => common.focusOutMenu()}>
                <content> 
                    <div className="input-form" style={{ textAlign: "center" }}>
                        <div className="animate__animated animate__rubberBand" style={{ margin: "5rem 0" }}>
                            <h4 className="notice-page-title" style={{color:"#fff"}}>{ANNOUNCEMENT}</h4>
                        </div>
                        <div className="row"></div>
                        <ul id="accordion" className="accordion" style={{ textAlign: "justify" }}>
                            {announcement && announcement.map((item,index) => {
                                return <li key={index}>
                                        <div className="notice-item" style={{ marginBottom: "0" }}>
                                            <div className="d-flex align-items-center justify-content-between">
                                                <p className="notice-title" onClick={clickEvent}>
                                                    {item.title}
                                                </p>
                                                <p className="notice-date" onClick={clickEvent}>{item.createdAt ? item.createdAt.substr(0, 13) : '2024년 00월 00일'}</p>
                                            </div>
                                        </div>
                                        <div className="link"></div>
                                        <ul className="submenu">
                                            <li style={{ paddingTop: "1rem",color:"#ebebeb" }}>
                                                <div dangerouslySetInnerHTML={{__html: decodeHtml(item.content)}}></div>
                                            </li>
                                        </ul>
                                    </li>
                            })}
                        </ul>
                    </div>
                </content>
            </div >
            <Footer />
        </>
    )
}
export default Announcement;